module.exports = __webpack_public_path__ + "static/media/licht-removebg.863a9753.png";